const baseUri = "";
const publicPath = "";

export const Paths = {
    getBaseUri: () => baseUri,

    getFullPath: (uri: string) => {
        if (!uri) {
            return baseUri;
        }
        return uri.startsWith("/") ? `${baseUri}${uri}` : `${baseUri}/${uri}`;
    },

    getStaticFullPath: (src: string) => (src.startsWith("/") ? `${publicPath}${src}` : `${publicPath}/${src}`),

    getFullPathWithHost: (uri: string) => (uri.startsWith("/") ? `${window.location.origin}${baseUri}${uri}` : `${window.location.origin}${baseUri}/${uri}`)
};
